<google-map #googleMap [options]="options" [width]="'100%'" [height]="mapHeight + 'px'">
  <map-marker *ngFor="let markerOption of overlays" [position]="markerOption.position">
  </map-marker>
</google-map>
